{
  "blocks": [
    {
      "id": "test-general-bloodwork",
      "kind": "test",
      "tags": ["lab", "her", "during-cycle", "testing", "ivf", "egg-freezing"],
      "title": "Fertility Hormone Panel",
      "subtitle": "Blood draw or Tasso collection for key reproductive hormones",
      "body": {
        "testName": "Fertility Hormone Panel (AMH, FSH, E2, LH, Progesterone)",
        "category": "blood-marker",
        "whatItMeasures": "Measures key reproductive hormones including AMH, FSH, estradiol (E2), luteinizing hormone (LH), and progesterone. These levels help your care team assess ovarian reserve, track ovarian response, and time critical steps like trigger shots or transfers.",
        "howItWorks": "A small blood sample may be collected at home with a Tasso device or drawn by a phlebotomist from a vein in your arm, depending on the service arranged by your care team. The sample is sent to the lab for hormone analysis, and results are usually available within a few hours. AMH can be collected on any cycle day; FSH and estradiol are usually timed to cycle day 2-4, while progesterone is often checked about a week after ovulation. Your clinic may combine an in-clinic blood draw with a monitoring ultrasound on the same visit to minimize trips. Arrive early in the morning if instructed; many clinics draw labs between 7-9 AM. Stay hydrated the night before and morning of to make collection easier. No fasting is required unless your clinic specifies otherwise.",
        "quickFacts": [
          {
            "kind": "sample",
            "value": "Blood"
          },
          {
            "kind": "time",
            "value": "5-10 min collection"
          },
          {
            "kind": "pain",
            "value": "Needle pinch"
          },
          {
            "kind": "prep",
            "value": "Cycle day depends on the marker"
          },
          {
            "kind": "results",
            "value": "Same day, often a few hours"
          }
        ],
        "turnaroundTime": "Same day (a few hours)",
        "costRange": {
          "low": 50,
          "high": 250
        },
        "atHome": true,
        "clinicRequired": true,
        "cycleDay": "Variable: any cycle day for AMH; day 2-4 for baseline FSH/E2/LH; repeated during monitoring; and about 7 days after ovulation for progesterone when confirming ovulation.",
        "markerTiming": [
          {
            "marker": "AMH",
            "timing": "Any cycle day",
            "reason": "AMH is relatively stable across the cycle and is used as an ovarian-reserve planning marker."
          },
          {
            "marker": "FSH",
            "timing": "Day 2-4, most often day 2 or 3",
            "reason": "Early-follicular FSH helps show the baseline pituitary signal before a dominant follicle changes the hormone pattern."
          },
          {
            "marker": "Estradiol (E2)",
            "timing": "Day 2-4 for baseline; repeated during stimulation or FET prep",
            "reason": "Baseline E2 shows whether the ovaries are quiet. During stimulation, rising E2 helps track follicle activity; each mature follicle often contributes roughly 200-300 pg/mL, but clinics interpret the trend with ultrasound findings."
          },
          {
            "marker": "LH",
            "timing": "Day 2-4 for baseline; mid-cycle if checking for a surge",
            "reason": "Baseline LH helps interpret brain-ovary signaling. A mid-cycle LH rise is a different use case because it signals possible ovulation."
          },
          {
            "marker": "Progesterone",
            "timing": "About 7 days after ovulation for ovulation confirmation; protocol-specific during FET or stimulation",
            "reason": "Progesterone rises after ovulation, so timing follows ovulation or the medication schedule rather than cycle day 2-4."
          }
        ],
        "dataPoints": [
          "dp-amh-level",
          "dp-fsh-level",
          "dp-estradiol-level",
          "dp-lh-level",
          "dp-progesterone-level"
        ],
        "section": "cycle-monitoring"
      },
      "sources": [
        {
          "title": "ESHRE guideline: ovarian stimulation for IVF/ICSI",
          "authors": "ESHRE Guideline Group on Ovarian Stimulation",
          "journal": "Human Reproduction Open",
          "year": 2020,
          "url": "https://academic.oup.com/hropen/article/2020/2/hoaa009/5826933",
          "evidenceLevel": "guideline"
        }
      ],
      "readTimeMinutes": 3
    }
  ],
  "relationships": [],
  "localeVariants": []
}
